export default __webpack_public_path__ + "static/media/meterreading-3.2cc9b051.png";